import { render, staticRenderFns } from "./RelatorioModal.vue?vue&type=template&id=9e85b832&scoped=true&"
import script from "./RelatorioModal.vue?vue&type=script&lang=js&"
export * from "./RelatorioModal.vue?vue&type=script&lang=js&"
import style0 from "./RelatorioModal.vue?vue&type=style&index=0&id=9e85b832&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e85b832",
  null
  
)

export default component.exports